import * as React from "react";
import PropTypes from 'prop-types';

const SvgIconTruck = props => {
  if (props.id !== "_svgicontruck") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 25 20" {...props}><g fill="none" fillRule="evenodd"><path d="M36-14h-48v48h48z" /><path d="M2.378 0h11.04c1.177 0 2.377 1.147 2.377 2.273v12.818c0 1.253-1.195 2.482-2.412 2.482H8.068a2.92 2.92 0 01-5.06 0h-.734C1.169 17.573 0 16.297 0 15.091V2.308C0 1.143 1.178 0 2.378 0zm3.16 17.782c.919 0 1.666-.75 1.666-1.673s-.747-1.674-1.667-1.674c-.919 0-1.667.751-1.667 1.674 0 .923.748 1.673 1.667 1.673zm11.687-12.97h2.754c.334 0 .758.038 1.567.5a.63.63 0 01.163.135l2.72 3.138c.026.03.05.064.07.1.487.852.501 1.777.501 1.88V15.9a.628.628 0 01-.628.627h-.762a2.925 2.925 0 01-2.892 2.51 2.925 2.925 0 01-2.892-2.51h-.602a.628.628 0 01-.627-.627V5.44c0-.347.28-.628.628-.628zm3.493 12.97c.92 0 1.667-.75 1.667-1.673s-.748-1.674-1.667-1.674c-.92 0-1.667.751-1.667 1.674 0 .923.748 1.673 1.667 1.673z" fill="#384048" /></g></svg>;
};

SvgIconTruck.displayName = "_svgicontruck";
SvgIconTruck.propTypes = {
  id: PropTypes.string
};
SvgIconTruck.defaultProps = {
  id: ''
};
export default SvgIconTruck;